import React, {useState} from "react";
import { PropsData } from "../../../context";
import { Modal, Typography, Button, Selector, FileUpload, Link, Loader } from "@virkesborsen/ui-component-library";
import { ContentContainer } from "./utils/utils";
import { generateForestandProperty } from "../../../../../api/services/property";
import {ErrorModal} from "../../../../../modals";
export const UploadForestandStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose, arbonicsData, updateCo2Deal}) => {
    const propsContext = React.useContext(PropsData);

    const [fileError, setFileError] = useState('')
    const [successText, setSuccessText] = useState('')

    const [file, setFile] = useState(null)
    const [isLoading,setIsLoading] = useState(false)
    const [errorModal,setErrorModal] = useState(false)

    const handleSubmit = async() => {
        setIsLoading(true)
        let propandFile = {...arbonicsData, "forestandFile":file}
       
        if (propandFile?.forestandFile && propandFile?.selectedProp){
            var formData = new FormData()
            formData.append('file', propandFile.forestandFile)
            formData.append('lmID', propandFile.selectedProp.ref)
            formData.append('designation_overwrite', propandFile.selectedProp.designation)
     

            const resp = await generateForestandProperty(formData)
            if (resp.ok){
                await propsContext.setOneProp(resp.data)
                let sbo = resp.data
                let co2FormData = new FormData()
                co2FormData.append('file', propandFile.forestandFile)
                co2FormData.append('stage', 'forestand')
                co2FormData.append('comments', 'Not sent, only finished step 2')
                const resp2 = await updateCo2Deal(co2FormData, false)
                handleNext({
                    data: {
                        sbo:sbo,
                        forestand_data_req: formData
                    },
                });
                setIsLoading(false)
            }
            else{
                setIsLoading(false)
                setErrorModal(true)
            }
        }
        else{
            setIsLoading(false)
            setErrorModal(true)
        }

        
    };

    const handleFileUpload = (data) => {
        if(data[0].valid){
            setFile(data[0].file)
            setSuccessText("Du har laddat upp en korrekt fil")
        }
    }

    async function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            
            reader.readAsText(file);
        });
    }

    const validateFiles = async (data) => {
        if(data.file.name.split(".")[1].toLowerCase() == "pcskogz"){
            setFileError("Din fil är en pcskog fil, kontakta kolkrediter@treebula.se")
            const co2FormData = new FormData()
            co2FormData.append('file', data.file)
            co2FormData.append('comments', "User tried to upload .pcskogz")
            await updateCo2Deal(co2FormData, false)
            return false;
        }

        const fileText = await Promise.resolve(readFileAsync(data.file))
        setFileError("Detta verkar inte vara en forestand fil")

        return fileText.indexOf("ForestandData") != -1
    }

    if (isLoading) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Typography variant="bodyMediumBaseRegular">
            Bearbetar din fil...
            </Typography>
            <Loader />
          </div>
        );
      }

    return (
        <>
            <Modal.Content>
                <ContentContainer>
                    <Typography variant="subheaderSmallMedium">Vald fastighet</Typography>
                    <Selector
                        name="selected-property"
                        variant="default"
                        onChange={() => { }}
                        options={[
                            {
                                label: arbonicsData.selectedProp.designation,
                                value: arbonicsData.selectedProp.ref
                            },
                        ]}
                    />
                    <Typography variant="subheaderSmallMedium">Ladda upp forestand fil</Typography>
                    <Typography variant="bodySmallRegular" className="neutral-pebble">Du behöver ladda upp en forestand fil för att vi ska kunna analysera din fastighetspotential. Forestand filen får bara innehålla en fastighet för att analysen skall bli rätt.</Typography>
                    <FileUpload
                        accept=".xml, .pcskogz"
                        buttonText="Ladda upp forestand"
                        errorText={fileError}
                        successText={successText}
                        label="Filer som stöds: XML"
                        onChange={handleFileUpload} 
                        validation={validateFiles} />
                    <Typography variant="subsectionHeaderSmallMedium">Vad är en forestand fil?</Typography>
                    <Typography variant="bodySmallRegular">Vi har skapat en informationssida för hur du bäst får tag på din forestand fil.<Link href="/u/forestand/" target="_blank" textColor="green"> Klicka här för att läsa mer.</Link></Typography>

                </ContentContainer>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    fullWidth
                    variant="primary"
                    onClick={handleSubmit}
                    label={"Nästa steg"}
                    disabled={successText == "Du har laddat upp en korrekt fil" ? false : true}
                    suffixIcon={"arrowRightSimple"}
                />
            </Modal.Footer>
            <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
        </>
    );
};

